export default Object.freeze({
  TYPE: {
    DIVA: 'diva',
    STRATEGIC: 'strategic',
    NEVER_OUT_OF_STOCK: 'never_out_of_stock',
    OLD: 'old',
  },
  STATE: {
    ACTIVE: 'active',
    CLOSED: 'closed',
    CANCELED: 'canceled',
    FULFILLED: 'fulfilled',
    REQUESTED: 'requested',
  },
});
